/*
 * Enumeration of available API model types
 */
export enum ModelType {
  part = 'part',
  supplierpart = 'supplierpart',
  manufacturerpart = 'manufacturerpart',
  partcategory = 'partcategory',
  partparametertemplate = 'partparametertemplate',
  parttesttemplate = 'parttesttemplate',
  projectcode = 'projectcode',
  stockitem = 'stockitem',
  stocklocation = 'stocklocation',
  location = 'location',
  stocklocationtype = 'stocklocationtype',
  stockhistory = 'stockhistory',
  asset = 'asset',
  assetassignment = 'assetassignment',
  repairorder = 'repairorder',
  repairorderitem = 'repairorderitem',
  repairorderaction = 'repairorderaction',
  build = 'build',
  buildstagetemplate = 'buildstagetemplate',
  buildstage = 'buildstage',
  productionplace = 'productionplace',
  buildline = 'buildline',
  builditem = 'builditem',
  buildoperation = 'buildoperation',
  buildoperationevent = 'buildoperationevent',
  buildoperationlabor = 'buildoperationlabor',
  buildoperationqualitycheck = 'buildoperationqualitycheck',
  qualitychecktemplate = 'qualitychecktemplate',
  operationreason = 'operationreason',
  company = 'company',
  purchaseorder = 'purchaseorder',
  purchaseorderlineitem = 'purchaseorderlineitem',
  purchaseorderextraline = 'purchaseorderextraline',
  salesorder = 'salesorder',
  salesorderextraline = 'salesorderextraline',
  salesordershipment = 'salesordershipment',
  returnorder = 'returnorder',
  returnorderlineitem = 'returnorderlineitem',
  returnorderextraline = 'returnorderextraline',
  importsession = 'importsession',
  address = 'address',
  contact = 'contact',
  owner = 'owner',
  user = 'user',
  group = 'group',
  reporttemplate = 'reporttemplate',
  labeltemplate = 'labeltemplate',
  pluginconfig = 'pluginconfig',
  contenttype = 'contenttype',
  selectionlist = 'selectionlist',
  error = 'error',
  qualification = 'qualification',
  energymeter = 'energymeter'
}
